import { Link } from 'react-router-dom';

import { MainTextRow } from '/src/features/live-activity/components/ui';
import { Identity } from '../EventCard';

export function SurveyResponseEvent({ liveEvent, identifyEvents }) {
  const { survey_id } = liveEvent.data?.attributes ?? {};

  return (
    <div>
      <MainTextRow>
        <Identity id={liveEvent.data?.visitor_id} identifyEvents={identifyEvents} />
        <span className="whitespace-pre">responded to </span>
        <Link className="text-link" to={`/addons/${survey_id}`}>
          survey
        </Link>
      </MainTextRow>
    </div>
  );
}
